import RegisterForm from 'components/Register/RegisterForm/RegisterForm';

export default RegisterForm;
